import React, { Fragment,useState,useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom'
import Breadcrumb from '../common/breadcrumb';
import axios from 'axios'
import { useForm } from "react-hook-form";
import { Camera, Image } from "react-feather"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Badge, Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { apiEndpoint, fileServer, MyProfile,Bio,MarkJecno,Designer,Password,Website,Save,EditProfile,Company,Username,UsersCountryMenu,AboutMe,UpdateProfile,UsersTableTitle,FirstName,LastName,Address,EmailAddress,PostalCode,Country, UsersTableHeader,City,Edit,Update,Delete, PhoneNumber} from '../../constant'
import  Avatar  from '../../assets/images/avtar/avatar-cleaning.png'
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';



const AmbientiLista = () => {

    const [data,setData] = useState([])
    const [allAreas, setAreas] = useState([{}])
    const [clientiPotenziali, setClientiPotenziali] = useState([])
    const [loading, setLoading] = useState(false)
    const [fileImage, setFile] = useState(null)
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const { register: registerDel, handleSubmit: handleSubmitDel, formState: { errors: errorsDel } } = useForm();
    const { register: registerPwd, handleSubmit: handleSubmitPwd, formState: { errors: errorsPwd }, reset } = useForm();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isErr, setErr] = useState('')
    const [modal, setModal] = useState();
    const [modalDel, setModalDel] = useState();
    const [modalImg, setModalImg] = useState();
    const [modalImgSee, setModalImgSee] = useState();
    const [errDel, setErrDel] = useState('')
    const [isLoggedOut, setLoggedOut] = useState(false)
    const [errPwd, setErrPwd] = useState('')
    const [image, setImage] = useState('')
    const [disabled, setDisabled] = useState(true)
    const [customerCode, setCustomerCode] = useState('')
    const [isMoved, setMoved] = useState(false)


    useEffect(() => {
        let mounted = true
        const getUser = async () => {
          const user = await axios.get(`${apiEndpoint}/aree-ambienti/fetch-aree`, {
            headers: {
              "x-access-token": localStorage.getItem('jwt')
            }
          })
          if(mounted) {
              setAreas(user.data)
              setLoading(true)
          }
        }
        getUser()
        return () => {
          mounted = false
        }
    }, [])

    if(isMoved) {
    return (<Redirect to={`${process.env.PUBLIC_URL}/clienti-potenziali/profilo/${customerCode}`} />)
    }


    return (
        <Fragment>
            <Breadcrumb title="Ambienti" parent="Aree e ambienti" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        {loading ? <div className="card">
                        {localStorage.getItem("role") === 'Admin' ? <div className="d-flex flex-row justify-content-between w-100 mb-2">
                          <div></div>
                          <div className="text-left">
                              <Link to={`${process.env.PUBLIC_URL}/aree-ambienti/ambienti/aggiungi`} className="btn btn-success cleaning-btn-login" type="submit" style={{marginRight: '2vw', marginTop: '2vh'}}>{"Aggiungi"}</Link>
                          </div>
                        </div> : null}
                          <div className="card-body datatable-react">
                            <div className="row">

                              {allAreas.map((item, index) => {
                                return (
                                  <div className="col-xl-4 col-md-4 col-sm-6">
                                  <div className="card">
                                      <div className="card-body text-center">
                                          <center>
                                                <img src={fileServer + item.PercorsoImmagine} alt={item.ambiente} className="img-aree-ambienti"/>
                                              </center>
                                              {localStorage.getItem("role") === "Admin" ? <Link to={`/aree-ambienti/ambienti/profilo/${item.ambiente}`}><h5 className="title-cleaning-dashboard">{item.ambiente}</h5></Link> : <h5 className="title-cleaning-dashboard">{item.ambiente}</h5>}
                                          </div>
                                      </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </div>: <div className="spinner-loading-cleaning"><div className="loader-box">
                          <div className="loader">
                            <div className="line bg-success"></div>
                            <div className="line bg-success"></div>
                            <div className="line bg-success"></div>
                            <div className="line bg-success"></div>
                          </div>
                        </div></div>}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default AmbientiLista;
